import React, { useContext, useEffect, useState } from 'react'

import { TheMasterContext } from '../../../../MyContexts/Master_Context';
import SelectImgComp from '../../../../MySections/ImagesSetter/SelectImgComp';


const SocialMdsTab = (props) => {
    const [theMaster] = useContext(TheMasterContext);
    const [tempMeds, setTempMed] = useState(theMaster["socialMds"] || [])

    const [facebookLink, setFacebookLink] = useState("");
    const [facebookIcon, setFacebookIcon] = useState("");

    const [instegramLink, setInstegramLink] = useState("");
    const [instegramIcon, setInstegramIcon] = useState("");

    const [whatsappLink, setWhatsappLink] = useState("");
    const [whatsappIcon, setWhatsappIcon] = useState("");

    useEffect(() => {
        setTheFacebookLink(tempMeds[0].url || "");
        setTheFacebookIcon(tempMeds[0].src || "");

        setInstegramLink(tempMeds[1].url || "");
        setInstegramIcon(tempMeds[1].src || "");

        setWhatsappLink(tempMeds[2].url || "");
        setWhatsappIcon(tempMeds[2].src || "");



    }, [])


    const setTheFacebookLink = (urlToSet) => {
        setFacebookLink(urlToSet);
        tempMeds[0].url = urlToSet;
        theMaster["socialMds"] = [...tempMeds];
    }

    const setTheFacebookIcon = (urlToSet) => {
        setFacebookIcon(urlToSet);
        tempMeds[0].src = urlToSet;
        theMaster["socialMds"] = [...tempMeds];
    }

    const setTheInstegramLink = (urlToSet) => {
        setInstegramLink(urlToSet);
        tempMeds[1].url = urlToSet;
        theMaster["socialMds"] = [...tempMeds];
    }
    const setTheInstegramIcon = (urlToSet) => {
        setInstegramIcon(urlToSet);
        tempMeds[1].src = urlToSet;
        console.log(tempMeds)
        theMaster["socialMds"] = [...tempMeds];
    }

    const setTheWhatsappLink = (urlToSet) => {
        setWhatsappLink(urlToSet);
        tempMeds[2].url = urlToSet;
        theMaster["socialMds"] = [...tempMeds];
    }
    const setTheWhatsappIcon = (urlToSet) => {
        setWhatsappIcon(urlToSet);
        tempMeds[2].src = urlToSet;
        console.log(tempMeds)
        theMaster["socialMds"] = [...tempMeds];
    }


    return (
        <>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_61"}>Facebook</label>
                <div className={"col-md-6 mb-2"}>
                    <label htmlFor={"validationCustom1_16"}>Facebook Link</label>
                    <div className={"input-group"}>
                        <input type="text" className={"form-control"} id={"validationCustom1_16"} placeholder={"facebook Link"} value={facebookLink}
                            onChange={(e) => { setTheFacebookLink(e.target.value) }}
                        />

                    </div>
                </div>
                <div className={"col-md-6 mb-2"}>
                    <label htmlFor={"validationCustom1_6"}>Facebook Icon</label>
                    <span className={"explanation mediumst fullROw"}>מוצג על הכפתור</span>
                    <SelectImgComp firstImgToDisp={facebookIcon ? facebookIcon : ""} theFunction={(fUrl) => setTheFacebookIcon(fUrl)} />
                </div>
            </div>
            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_61"}>Instegram</label>
                <div className={"col-md-6 mb-2"}>
                    <label htmlFor={"validationCustom1_16"}>Instegram Link</label>
                    <div className={"input-group"}>
                        <input type="text" className={"form-control"} id={"validationCustom1_16"} placeholder={"Instegram Link"} value={instegramLink}
                            onChange={(e) => { setTheInstegramLink(e.target.value) }}
                        />

                    </div>
                </div>
                <div className={"col-md-6 mb-2"}>
                    <label htmlFor={"validationCustom1_6"}>Instegram Icon</label>
                    <span className={"explanation mediumst fullROw"}>מוצג על הכפתור</span>
                    <SelectImgComp firstImgToDisp={instegramIcon ? instegramIcon : ""} theFunction={(fUrl) => setTheInstegramIcon(fUrl)} />
                </div>
            </div>

            <div className={"col-md-12 mb-2"}>
                <label htmlFor={"validationCustom1_61"}>WhatssUp</label>
                <div className={"col-md-6 mb-2"}>
                    <label htmlFor={"validationCustom1_16"}>WhatssUp Link</label>
                    <div className={"input-group"}>
                        <input type="text" className={"form-control"} id={"validationCustom1_16"} placeholder={"WhatssUp Link"} value={whatsappLink}
                            onChange={(e) => { setTheWhatsappLink(e.target.value) }}
                        />

                    </div>
                </div>
                <div className={"col-md-6 mb-2"}>
                    <label htmlFor={"validationCustom1_6"}>WhatssUp Icon</label>
                    <span className={"explanation mediumst fullROw"}>מוצג על הכפתור</span>
                    <SelectImgComp firstImgToDisp={whatsappIcon ? whatsappIcon : ""} theFunction={(fUrl) => setTheWhatsappIcon(fUrl)} />
                </div>
            </div>

          


        </>

    );
}

export default SocialMdsTab;